import { Sparkles } from "lucide-react";

/**
 * Reusable "coaching" empty state. Uses a warm, encouraging tone so lay users
 * don't feel like they've hit a dead-end. `bullets` optional — each bullet is
 * a plain string describing what to do next.
 */
export function EmptyStateCoach({
  icon: Icon = Sparkles,
  title,
  description,
  bullets,
  action,
  testId = "empty-coach",
}) {
  return (
    <div className="card-surface p-10 sm:p-12 text-center anim-in" data-testid={testId}>
      <div
        className="mx-auto w-14 h-14 rounded-2xl flex items-center justify-center mb-5"
        style={{ background: "var(--ai-bg)", border: "1px solid var(--ai-border)" }}
      >
        <Icon className="w-6 h-6" style={{ color: "var(--ai-text)" }} />
      </div>
      <h3 className="font-display text-2xl font-bold mb-2" style={{ color: "var(--text-primary)" }}>
        {title}
      </h3>
      <p className="text-[15px] leading-relaxed max-w-md mx-auto mb-6" style={{ color: "var(--text-secondary)" }}>
        {description}
      </p>
      {bullets && bullets.length > 0 && (
        <ul className="text-sm text-left inline-block space-y-2 mb-6" style={{ color: "var(--text-primary)" }}>
          {bullets.map((b) => (
            <li key={b} className="flex items-start gap-2">
              <span
                className="mt-1 inline-block w-1.5 h-1.5 rounded-full flex-shrink-0"
                style={{ background: "var(--action)" }}
              />
              <span>{b}</span>
            </li>
          ))}
        </ul>
      )}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
